import {getApiDomain} from "../../util/domains";

export function setBranchOffices(state, branchoffices) {
    state.branchoffices = branchoffices.map(b => {
        return { value: b.id, label: b.name };
    });
}

export function setTypeUpdates (state, data) {
  state.type_updates = data;
}
export function setNextId (state, data) {
    if (data.validate && state.action === "create"){
        let parameter = state.type_updates.find(el => el.id === state.selectedCashRegisterUpdate.update_type_id)
        if (parameter && ['05', '06', '01','07'].includes(parameter.code_parameter)) {
            state.selectedCashRegisterUpdate.number_document = data.data;
            state.selectedCashRegisterUpdate.id_sug = data.data;
        }
    }else{
        state.selectedCashRegisterUpdate.id_sug = data.data;
    }

}

export function setListCashUpdates (state, data) {
  state.listCashUpdates = data;
}


export function setSelectedCashUpdate (state, data) {
  state.selectedCashRegisterUpdate = data;
  state.selectedCashRegisterUpdate.id_sug = data.id;
}

export function setAction (state, action) {
  state.action = action;
}

export function getAction (state) {
  return state.action;
}

export function clearCashUpdate (state) {
  state.selectedCashRegisterUpdate = {};
}

export function modifyIsDisabled (state, bol) {
  state.isDisabled = bol;
}

export function setPerPage (state, perPage) {
    state.params.page = 1
    state.params.perPage = perPage
}

export function setPage (state, page) {
    state.params.page = page
}

export function setDefaultParams(state, data) {
    state.params.branchoffice_id = parseInt(data.branchoffice_id),
    state.params.box_id = data.box_id
}
export function setDefaultBoxUser(state, data) {
    state.selectedCashRegisterUpdate.box_id = data
}


export function resetFileNamePdfCashRegister(state) {
    state.fileNamePdfCashRegister = "";
    state.fileNamePdfCashRegisterSquareEmail = "";
}

export function setShowPdfCashRegister(state, value) {
    state.showPdfCashRegister = value;
}

export function setFileNamePdfCashRegister(state, value) {
    state.fileNamePdfCashRegister = getApiDomain() + "/storage/" + value;
    state.fileNamePdfCashRegisterEmail = "/" + value;
}

export function setLoadingPdf(state, value) {
    state.loadingPdf = value;
}



// WEBPACK FOOTER //
// ./src/modules/cash-registers-updates/mutations.js